export enum ROLE {
    Admin = 'Admin',
    User = 'User',
}
